import Icon from "@ant-design/icons";

const DiningRoomFurnitureSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M1690 5070 c-19 -19 -20 -33 -20 -440 l0 -420 -27 -6 c-165 -36 -295
-133 -363 -270 -82 -167 -32 -274 128 -274 60 0 61 0 72 -34 16 -49 83 -121
136 -146 62 -31 156 -31 218 -1 54 27 110 87 132 141 l16 40 60 0 c160 0 210
108 127 275 -66 135 -198 233 -361 269 l-28 6 0 420 c0 407 -1 421 -20 440
-11 11 -27 20 -35 20 -8 0 -24 -9 -35 -20z m112 -971 c123 -26 225 -107 280
-224 50 -108 80 -100 -357 -100 -437 0 -407 -8 -357 100 54 113 149 192 267
221 65 16 102 17 167 3z m52 -468 c-23 -38 -82 -71 -129 -71 -47 0 -106 33
-129 71 l-17 29 146 0 146 0 -17 -29z"
      />
      <path
        d="M3360 5070 c-19 -19 -20 -33 -20 -440 l0 -420 -27 -6 c-164 -36 -296
-134 -362 -269 -83 -167 -33 -275 127 -275 l60 0 16 -40 c22 -54 78 -114 132
-141 62 -30 156 -30 218 1 53 25 120 97 136 146 11 34 12 34 72 34 160 0 210
107 128 274 -68 137 -198 234 -362 270 l-28 6 0 420 c0 407 -1 421 -20 440
-11 11 -27 20 -35 20 -8 0 -24 -9 -35 -20z m112 -971 c123 -26 225 -107 280
-224 50 -108 80 -100 -357 -100 -437 0 -407 -8 -357 100 54 113 149 192 267
221 65 16 102 17 167 3z m52 -468 c-23 -38 -82 -71 -129 -71 -47 0 -106 33
-129 71 l-17 29 146 0 146 0 -17 -29z"
      />
      <path
        d="M35 3337 c-13 -21 -15 -203 -13 -1651 3 -1598 3 -1628 22 -1642 27
-19 42 -18 66 6 19 19 20 33 20 545 l0 525 643 -2 642 -3 5 -530 5 -529 27
-15 c24 -14 28 -14 47 3 21 19 21 26 21 562 l0 543 -30 34 c-27 31 -30 41 -30
103 0 45 -7 83 -19 109 -23 51 -89 111 -138 124 -25 7 -222 11 -563 11 -431
-1 -532 -3 -565 -15 -22 -8 -41 -15 -42 -15 -2 0 -3 22 -3 49 l0 48 73 5 c105
7 168 43 210 123 22 40 22 47 25 660 4 692 3 702 -56 768 -50 55 -102 77 -184
77 l-68 0 0 46 c0 25 -5 54 -10 65 -15 28 -65 25 -85 -4z m230 -221 c67 -28
65 -6 65 -707 l0 -631 -34 -34 c-32 -32 -38 -34 -100 -34 l-66 0 0 710 0 710
50 0 c28 0 66 -6 85 -14z m1046 -1716 c31 -23 49 -72 49 -137 l0 -43 -615 0
-615 0 0 66 c0 62 2 68 34 100 l34 34 542 0 c530 0 543 0 571 -20z"
      />
      <path
        d="M5000 3341 c-5 -11 -10 -40 -10 -65 l0 -46 -67 0 c-83 0 -135 -22
-185 -77 -59 -66 -60 -76 -56 -768 3 -618 3 -620 25 -662 44 -82 122 -123 232
-123 l51 0 0 -51 c0 -45 -2 -50 -17 -44 -57 23 -124 25 -620 23 -590 -3 -562
0 -627 -65 -45 -44 -66 -99 -66 -177 0 -62 -3 -72 -30 -103 l-30 -34 0 -543
c0 -536 0 -543 21 -562 19 -17 23 -17 47 -3 l27 15 5 529 5 530 643 3 642 2 0
-525 c0 -512 1 -526 20 -545 24 -24 39 -25 66 -6 19 14 19 44 22 1642 2 1448
0 1630 -13 1651 -20 29 -70 32 -85 4z m-10 -921 l0 -710 -66 0 c-62 0 -68 2
-100 34 l-34 34 0 631 c0 698 -2 678 63 706 18 8 56 14 85 15 l52 0 0 -710z
m-34 -1034 c32 -32 34 -38 34 -100 l0 -66 -615 0 -615 0 0 43 c0 63 16 109 47
134 l28 23 543 0 544 0 34 -34z"
      />
      <path
        d="M1123 2461 c-118 -54 -147 -217 -53 -311 54 -54 88 -60 339 -60 l221
0 2 -1016 c3 -992 3 -1016 22 -1030 14 -10 50 -14 128 -14 95 0 110 2 128 20
11 11 20 30 20 43 -1 51 61 1305 66 1335 l5 32 559 0 559 0 5 -32 c4 -29 67
-1293 66 -1340 0 -10 9 -27 20 -38 18 -18 33 -20 128 -20 78 0 114 4 128 14
19 14 19 38 22 1030 l2 1016 222 0 c143 0 235 4 261 12 84 25 146 123 133 212
-9 59 -56 123 -109 147 -41 18 -87 19 -1437 19 -1350 0 -1396 -1 -1437 -19z
m2851 -110 c35 -33 36 -92 1 -126 l-24 -25 -1391 0 -1391 0 -24 25 c-43 42
-27 123 29 145 11 5 635 8 1398 7 l1376 -2 26 -24z m-2054 -298 c0 -21 -20
-443 -45 -938 -25 -495 -45 -917 -45 -937 l0 -38 -45 0 -45 0 0 975 0 975 90
0 90 0 0 -37z m1174 -15 c3 -29 7 -92 8 -141 l3 -87 -546 0 -545 0 3 88 c2 48
6 111 9 140 l5 52 529 0 529 0 5 -52z m286 -923 l0 -975 -45 0 -45 0 0 38 c0
20 -20 442 -45 937 -25 495 -45 917 -45 938 l0 37 90 0 90 0 0 -975z m-270
571 c0 -13 3 -44 6 -70 l7 -46 -563 0 -563 0 7 46 c3 26 6 57 6 70 l0 24 550
0 550 0 0 -24z"
      />
    </g>
  </svg>
);

const DiningRoomFurnitureIcon = (props) => (
  <Icon component={DiningRoomFurnitureSvg} {...props} />
);

export default DiningRoomFurnitureIcon;
